import {Component, EventEmitter, HostBinding, inject, Output} from '@angular/core';
import {AvatarAsLetterDirectiveModule, UserHttpService} from "@lcms/shared/data-access-user";
import {BehaviorSubject, debounceTime, map, scan, switchMap, tap} from "rxjs";
import {Router} from "@angular/router";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {InlineSVGModule} from "ng-inline-svg-2";
import {FormsModule} from "@angular/forms";
import {SelectFilterComponent} from "@lcms/shared/lazy-load-select";
import {NgxShimmerLoadingModule} from "ngx-shimmer-loading";
import {SearchFormationService} from "../../serivce/search-formation.service";

@Component({
  selector: 'lcms-search-formation-resultat',
  standalone : true,
  imports: [CommonModule,
    TranslateModule,
    InlineSVGModule,
    AvatarAsLetterDirectiveModule,
    FormsModule,
    SelectFilterComponent,
    NgxShimmerLoadingModule],
  templateUrl: './search-formation-resultat.component.html',
  styleUrls: ['./search-formation-resultat.component.scss'],
})
export class SearchFormationResultatComponent  {
  userService = inject(UserHttpService)
  // menu menu-sub menu-sub-dropdown
  @HostBinding('class') class = ' p-7 w-325px w-md-375px';
  @HostBinding('attr.data-kt-menu') dataKtMenu = 'true';
  @HostBinding('attr.data-kt-search-element') dataKtSearch = 'content';
  typeCatalogue:any = [{id:1 , label : 'Formation/Module' ,value : 'catalogue'} ,{id:2 , label : 'Ressources' , value: 'ressources'}]
  @Output() onClickEnter = new EventEmitter<boolean>();
  categoriesLoad = false
  selectedCategories : any[]= []
  selectedtype : any[] =[]
  selectedSub  = new BehaviorSubject<any[]>([])
  selectedTypeSub  = new BehaviorSubject<any[]>([])
  selected$  = this.selectedSub.asObservable()
  selectedType$  = this.selectedSub.asObservable()
  router=inject(Router);
  searchSerive=inject(SearchFormationService)
  keyword = '';
  searching = this.searchSerive.searching;
  last_page = 1;
  tagPage = new BehaviorSubject<any>({ page: 1,searchTerm: ''});
  tagsPage$ = this.tagPage.asObservable();
  listCategories$ =    this.tagsPage$.pipe(
    tap(() => this.categoriesLoad = true ),
    switchMap(({page,searchTerm})=> this.userService.getInterest(page,searchTerm,1).pipe(
      map((data)=>{
        this.last_page = data?.last_page;
        return data?.data
      }),

    )),scan((acc, data)=>{
      // If the search term has changed or if it's the first load
      if(this.tagPage.value.page !== 1){
        return [...acc, ...data];
      }else{
        return data;
      }
    }),
    tap(() => this.categoriesLoad = false ),
  )

  new_result$=this.searchSerive.searchResult$.pipe(
    map((res)=>{
      res=Object.keys(res)
        .filter((key:any)=>res[key]?.length>0)
        .map((key:any)=>{
          const row=res[key][0];
          return {
            title:row?._source?.title || row?._source?.word || row?._source?.metadata?.title || row?._source?.first_name+' '+row?._source?.last_name,
            image:row?._source?.image || row?._source?.metadata?.thumbnail,
            category:key,
            nbr:res[key].length,
          }

        })
        this.searchSerive.dataResult.next(res)
      return res;
    })
  )

  search(keyword: string) {
    if(!this.searchSerive.checkKeyword(keyword)) this.searchSerive.searchKeyworld.next(keyword)
    this.keyword = keyword;
  }

  clearSearch() {
    this.keyword = '';
  }
  navigateToSearch() {
    this.searchSerive.searchByAnswer.next(true);
    this.searchSerive.setCheckedCategory('');
    this.router.navigate(['/search-Formation'], { queryParams: { query: this.searchSerive.searchKeyworld.value } });
  }
  navigateWithCategory(item:any){
    console.log('navigating ...',this.searchSerive.searchKeyworld.value)
    this.router.navigate(['/search-Formation'], { queryParams: { query: this.searchSerive.searchKeyworld.value } });
    this.searchSerive.setCheckedCategory(item.category || '');
  }
  handleKeyPress(event:any) {
    // this.searchSerive.searchByAnswer.next(false);
    // setTimeout(() => {
    //   this.onClickEnter.emit(true);
    //   this.searchSerive.searchByAnswer.next(true);
    //   this.router.navigate(['/search-Formation'], { queryParams: { query: event.target.value } });
    // },800)

    this.keyword=event.target.value;
    // if(!this.searchSerive.checkKeyword(event.target.value || '')) this.searchSerive.searchKeyworld.next(event.target.value)
  }
  searchTag(searchTerm: string) {
    this.tagPage.next({page:1,searchTerm: searchTerm})
  }

  onSelectedCateChange(selectedItem: any) {

    const existingIndex = this.selectedCategories.findIndex((u: any ) => u.id === selectedItem.id);

    if (existingIndex === -1) {
      // L'utilisateur n'est pas déjà présent, alors on l'ajoute
      this.selectedCategories.push(selectedItem);
      // this.selectedSub.next(this.selectedCategories)
      // this.searchSerive.tags.next(this.selectedCategories)
      this.onClickEnter.emit(true);
    } else {
      // L'utilisateur est déjà présent, on le supprime
      this.selectedCategories.splice(existingIndex, 1);
      // this.selectedSub.next(this.selectedCategories)
      // this.searchSerive.tags.next(this.selectedCategories)
      // this.onClickEnter.emit(true);
    }
    //   this.autocomplete.clear();
  }

  removecate(item: any) {
    this.selectedCategories  = this.selectedCategories.filter((cat :any)=>cat.id !==item.id)
    this.selectedSub.next(this.selectedCategories)
    this.searchSerive.tags.next(this.selectedCategories)
    this.onClickEnter.emit(true);
  }
  searchType(searchTerm: string) {
    this.typeCatalogue.filter((tag : any) => tag === searchTerm)

  }

  onSelectedTypeChange(selectedItem: any) {

    const existingIndex = this.selectedtype.findIndex((u: any ) => u.id === selectedItem.id);

    if (existingIndex === -1) {
      // L'utilisateur n'est pas déjà présent, alors on l'ajoute
      this.selectedtype.push(selectedItem);
      this.selectedTypeSub.next(this.selectedtype)
      this.searchSerive.typeFormation.next(this.selectedtype)
      this.onClickEnter.emit(true);
    } else {
      // L'utilisateur est déjà présent, on le supprime
      this.selectedtype.splice(existingIndex, 1);
      this.selectedTypeSub.next(this.selectedtype)
      this.searchSerive.typeFormation.next(this.selectedtype)
      this.onClickEnter.emit(true);
    }
    //   this.autocomplete.clear();
  }

  removeType(item: any) {
    this.selectedtype  = this.selectedtype.filter((cat :any)=>cat.id !==item.id)
    this.selectedTypeSub.next(this.selectedtype)
    this.searchSerive.typeFormation.next(this.selectedtype)
    this.onClickEnter.emit(true);
  }
  tagsloadMor(loadMore:number) {
    const page = this.tagPage.value.page;
    if(page+1 <= this.last_page){
      const searchTerm = this.tagPage.value.searchTerm;
      this.tagPage.next({page:page+loadMore,searchTerm: searchTerm})
    }
  }

  handleSearchClicked(){
    //
    console.log('tags : ',this.selectedCategories)
    console.log('keyworld : ',this.keyword)
    this.searchSerive.tags.next(this.selectedCategories)
    this.searchSerive.searchKeyworld.next(this.keyword)
    this.searchSerive.searchByAnswer.next(false);
    // this.onClickEnter.emit(true);
    // this.searchSerive.searching.next(true)
    // this.router.navigate(['/search-Formation'], { queryParams: { query: this.searchSerive.searchKeyworld.value } });

  }
}
